"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_81_52_1 = void 0;
/**
 * removes Fuehrungsrinnen if set and HasNoRinne is true
 */
const migration_81_52_1 = (json) => {
    var _a;
    if (((_a = json.Fuehrungsrinnen) === null || _a === void 0 ? void 0 : _a.length) && json.HasNoRinne) {
        json.Fuehrungsrinnen = [];
    }
    return json;
};
exports.migration_81_52_1 = migration_81_52_1;
//# sourceMappingURL=migration_81_52_1.js.map